<div class="form-group">
  <input type="tel" class="form-control" maxlength="19" [class.form-error]="hasError || invalid || errorNovin"
    (keyup)="creditPattern()" [(ngModel)]="selectedCard" required>
  <a *ngIf="!hideList" class="saved-icon" data-toggle="modal" data-target="#cards">
    <img src="assets/img/Sheba-input-icon.svg" alt="">
  </a>
  <span class="floating-label">{{title}}</span>
  <span class="star">*</span>
  <span *ngIf="hasError" class="errorInput">پر کردن این فیلد الزامی است.</span>
  <span *ngIf="invalid" class="errorInput">کارت وارد شده معتبر نیست</span>
  <span *ngIf="errorNovin" class="errorInput">شماره کارت وارد شده متعلق به بانک اقتصاد نوین نمی باشد.</span>
</div>

<div class="modal fade" tabindex="-1" role="dialog" id="cards" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="width: 95%">
      <div class="modal-body">
        <h1 class="header1">کارت های ذخیره شده: </h1>
        <div class="search">
          <div class="form-group">
            <input type="text" [(ngModel)] = "searchTitle"
                   (keyup)="searchEntity()"
                   (keydown.backspace)="noSerachFilter()"
                   class="form-control searchInput">
            <span *ngIf="searchTitle === ''" class="floating-label-search"> جستجوی کارت مقصد</span>
          </div>
        </div>
        <div *ngIf="loadingCards" style="margin-top: 100px">
          <app-loader [loading]="loadingCards" [title] = "'پیامی'"></app-loader>
        </div>
        <div *ngIf="(cardList === null || cardList.length === 0) && !loadingCards" style="margin: 50px;">
          <app-empty-box [title]="'کارتی'"></app-empty-box>
        </div>
        <ul class="savedItem scroll" style="margin-top: 5px;">
          <li *ngFor="let card of cardList;let i= index" (click)="sendParentNotification(i)">
            <img class="letf-img" *ngIf="card.bank !== '' && card.bank !== undefined"
              [src]='"assets/img/Banks/"+card.bank+".png"' alt="">
            <div class="h-div">
              <span>{{card.title}}</span>
              <span class="farsiNumber">{{card.pan}}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="modal-footer simple-footer">
        <button class="btn" data-dismiss="modal">بستن</button>
      </div>
    </div>
  </div>
</div>
